import Vue from "vue";
import App from "./App.vue";
import "./style.scss";
import router from "./router";
import store from "./store";
import { setI18nLanguage } from "./i18n";
import vuetify from "./plugins/vuetify";
import "@babel/polyfill";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import pt_BR from "vee-validate/dist/locale/pt_BR.json";
import Container from './components/Container';
import { languages_info } from "./services/localizations";

/** VeeValidate */
localize("pt_BR", pt_BR);

/** Vue Global Components  */
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component('container', Container);

import "./validators";
/** /VeeValidate */

/** Moment */
import moment from "moment";
moment.locale("pt");
Vue.prototype.$moment = moment;

/** Axios */
import axios from "axios";
axios.defaults.baseURL = "/api";
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.interceptors.response.use(
  response => response,
  error => {
    const status = error.response ? error.response.status : null;
    switch (status) {
      case 401:
        if (localStorage.getItem("token")) {
          try {
            return store
              .dispatch("auth/refreshTokens")
              .then(() =>
                axios.request({
                  ...error.config,
                  baseURL: "",
                  headers: {
                    ...error.config.headers,
                    Authorization: store.state.auth.access_token
                  }
                })
              )
              .catch(error => Promise.reject(error));
          } catch (error) {
            router.push({ name: "logout" });
          }
        } else {
          router.push({ name: "login" });
        }
        break;
      case 403:
        store.commit("sendMessage", {
          text: "Você não está autorizado a realizar esta ação"
        });
        break;
    }

    return Promise.reject(error);
  }
);
Vue.prototype.$http = axios;
/** /Axios */

router.beforeEach((to, from, next) => {
  const no_auth_pages = [
    "login",
    "senha",
    "recuperar",
    "logout"
  ];

  if (!no_auth_pages.find(page => page == to.name)) {
    const access_token = store.getters["auth/getAccessToken"];

    if (!access_token) {
      store.dispatch("auth/refreshTokens").then(new_token => {
        if (!!new_token) {
          next();
        } else {
          next("/login");
        }
      });
    } else {
      next();
    }
  } else {
    const language_browser = navigator.language.split("-").join("_") || "en_US";
    setI18nLanguage({
      id: language_browser,
      without_country: languages_info[language_browser]?.without_country
    });

    next();
  }
});

/** Vue the Mask  */
import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

/** vuetify-money */
import "./plugins/vuetify-money";

import VueI18n from "vue-i18n";
Vue.use(VueI18n);
Vue.config.productionTip = false;

const i18n = new VueI18n({
  locale: store.getters.getLocale,
  messages: {
    en: {
      models: {
        user: "no user | user | users",
        user_name: "no name | name | names",
        user_email: "no email | email | emails",
        user_role: "no role | role | roles",
        user_type: "no type | type | types",
        user_administrator: "administrator",
        user_default: "Default"
      },
      system: {
        action: "no action | action | actions",
        new: "new | news",
        items_per_page: "Items per page",
        search_for: "Search for",
        language: "Language",
        loading: "loading"
      }
    },
    "pt-pt": {
      models: {
        user: "nenhum utilizador | utilizador | utilizadores",
        user_name: "nenhum nome | nome | nomes",
        user_email: "nenhum email | email | emails",
        user_role: "nenhuma cargo | cargo | cargos",
        user_type: "nenhum tipo | tipo | tipos",
        user_administrator: "Administrador",
        user_default: "Normal"
      },
      system: {
        action: "nenhuma acção | acção | acções",
        new: "novo | novos",
        items_per_page: "Linhas por página",
        search_for: "Buscar por",
        language: "Idioma",
        loading: "A carregar"
      }
    },
    "pt-br": {
      models: {
        user: "nenhum usuário | usuário | usuários",
        user_name: "nenhum nome | nome | nomes",
        user_email:
          "nenhum correio eletrônico | correio eletrônico | correios eletrônicos",
        user_role: "nenhuma função | função | funções",
        user_type: "nenhum tipo | tipo | tipos",
        user_administrator: "Administrador",
        user_default: "Padrão"
      },
      system: {
        action: "nenhuma ação | ação | ações",
        new: "novo | novos",
        items_per_page: "Linhas por página",
        search_for: "Buscar por",
        language: "Idioma",
        loading: "Carregando"
      }
    },
    ru: {
      models: {
        user: "нет пользователей | пользователь | пользователи",
        user_name: "без имени | название | имена",
        user_email: "нет электронной почты | Эл. адрес | электронная почта",
        user_role: "Не работает | род занятий | функции",
        user_type: "нет типа | тип | типы",
        user_administrator: "администратор",
        user_default: "нормальный"
      },
      system: {
        action: "бездействие | действие | действия",
        new: "новый | новый",
        items_per_page: "Строк на страницу",
        search_for: "Ищи",
        language: "язык",
        loading: "загрузка"
      }
    }
  }
});

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
